import React from 'react'

export interface InputProps extends React.HTMLProps<HTMLInputElement> {
  /**
   * The html input type to use.
   * @default "text"
   */
  type?: 'text' | 'number'
  /**
   * Show a label above the input.
   */
  placeholder?: string
  /**
   * If `true`, the input will take up the error style.
   */
  error?: boolean
  /**
   * If `true`, the input will take up the full width of its container.
   */
  isFullWidth?: boolean
  /**
   * If `true`, the input will be disabled.
   * @default "false"
   */
  isDisabled?: boolean
  /**
   * If `true`, the input will be required.
   */
  isRequired?: boolean
  /**
   * The html input name
   */
  inputName: string
  /**
   * The html input id
   */
  id: string
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (props, ref) => {
    const {
      placeholder = 'Text',
      type = 'text',
      error,
      isFullWidth,
      inputName,
      id,
      isRequired,
      isDisabled,
      ...rest
    } = props
    const width = isFullWidth ? 'w-full' : 'w-auto'
    return (
      <input
        ref={ref}
        type={type}
        name={inputName}
        id={id}
        disabled={isDisabled}
        required={isRequired}
        className={`form-input text-sm px-3 py-2 border block outline-none rounded-md ${width} focus:bg-error-100 focus:border-flamingo-500
           ${
             error
               ? 'text-flamingo-500 border-flamingo-500 bg-error-50'
               : 'border-gray bg-gray-50'
           }
           ${isDisabled ? 'text-dark-700' : 'text-black'}`}
        placeholder={placeholder}
        {...rest}
      />
    )
  }
)
